// components/Tables/PaymentsTable.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoice, faDownload } from '@fortawesome/free-solid-svg-icons';

const PaymentsTable = ({ data = [], onDownloadInvoice, invoiceLoading, childId, kgId }) => {
  return (
    <div>
      {/* Кнопка скачивания счета над таблицей */}
      <div className="d-flex justify-content-end mb-3">
        <button 
          className="btn btn-outline-primary"
          onClick={onDownloadInvoice}
          disabled={invoiceLoading}
        >
          <FontAwesomeIcon icon={faFileInvoice} className="me-2" />
          {invoiceLoading ? 'Завантаження...' : 'Завантажити рахунок для сплати послуг харчування'}
        </button>
      </div>

      <div className="table-responsive">
        <table className="table table-history mb-0">
          <thead>
            <tr>
              <th>Номер</th>
              <th>Дата</th>
              <th>Сума</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((payment, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{payment.date_pay	? new Date(payment.date_pay).toLocaleDateString('uk-UA') : '-'}</td>
                  <td>{payment.summ && +payment.summ.replace(/\$/g, '') || 0} грн.</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-4">
                  Немає даних про оплати
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PaymentsTable;